import { useRedirect } from 'react-admin';

import { ACTUAL_LANDING_PAGE } from '@app/constants';

/**
 * Technically the ListMedia component is the true "Dashboard" page.
 * Implementing this with a redirect
 * allows the "Media" menu item to be highlighted.
 */
export default function DashboardPage() {
  const redirect = useRedirect();
  redirect(ACTUAL_LANDING_PAGE);
  return <></>;
}
